import React from 'react';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters
} from '../../../../../../products/productsTypes';
import { ThreeDStockProductsCompactListItemInfoProduct } from './ThreeDStockProductsCompactListItemInfo.types';

import { ThreeDStockProductsCompactListItemInfoBrand } from './components/ThreeDStockProductsCompactListItemInfoBrand';

import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Translate } from '../../../../../../../helpers/Translate';

import { ProductPath } from '../../../../../../products/ProductPath';
import { words } from '../../../../../../../locales/keys';

interface ThreeDStockProductsCompactListItemInfoProps {
  product: ThreeDStockProductsCompactListItemInfoProduct;
  changeProductsFilters: ChangeProductsFiltersFunc;
  productsFilters: FetchProductsFilters;
}

function ThreeDStockProductsCompactListItemInfo({
  product,
  changeProductsFilters,
  productsFilters
}: ThreeDStockProductsCompactListItemInfoProps) {
  return (
    <div className="flex-1 min-w-20 px-3 py-2 text-sm flex flex-col items-start gap-0.5">
      <NextLinkHelper
        className="font-semibold truncate max-w-full"
        dataGa="products-product-goto-product-page-link"
        href={ProductPath.show(product.nanoId)}
      >
        <div className="absolute inset-0 z-1" />
        {product.name}
      </NextLinkHelper>

      <div className="flex gap-2">
        {product.nda && (
          <span className="bg-yellow-200 text-black px-1 text-xs rounded uppercase">
            <Translate id={words.nda} />
          </span>
        )}

        <ThreeDStockProductsCompactListItemInfoBrand
          changeProductsFilters={changeProductsFilters}
          product={product}
          productsFilters={productsFilters}
        />
      </div>
    </div>
  );
}

export default ThreeDStockProductsCompactListItemInfo;
